import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Award, TrendingUp } from 'lucide-react';

interface LeadCardVideoTopCapturaProps {
  videoName: string;
  thumbnail?: string;
  leadCount: number;
  growth: number;
}

export function LeadCardVideoTopCaptura({ 
  videoName, 
  thumbnail, 
  leadCount, 
  growth 
}: LeadCardVideoTopCapturaProps) {
  useLanguage();
  return (
    <Card className="rounded-[14px] shadow-[0_4px_14px_rgba(0,0,0,0.04)] 
                     hover:shadow-[0_8px_24px_rgba(0,0,0,0.08)] 
                     transition-all duration-300 border-2 border-[#2F6FED]/10 min-h-[160px]">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-3">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {translateInterfaceText("Vídeo com Maior Captura")}</CardTitle>
        <Award className="h-5 w-5 text-yellow-500" />
      </CardHeader>
      <CardContent>
        {thumbnail && (
          <img 
            src={thumbnail} 
            alt={videoName}
            className="w-full h-24 object-cover rounded-lg mb-4"
          />
        )}
        <h3 className="text-lg font-bold text-foreground mb-2 truncate">
          {videoName}
        </h3>
        <div className="flex items-baseline gap-2">
          <p className="text-2xl font-bold text-[#2F6FED]">
            {leadCount} {" "}{translateInterfaceText("leads")}</p>
          <span className="text-sm font-medium text-green-600 flex items-center gap-1">
            <TrendingUp className="h-3 w-3" />
            +{growth}%
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
